$(function () {
    $(".OritainBlog #NewsCategoryFilter").on("change", function (e) {
        e.preventDefault();
        const data = $(this).serialize();
        const url = ($(this).val() !== '') ? location.pathname + "?" + data : location.pathname;
        const toRefresh = [".blog-section-refresh"];
        loadAjaxContent(url, toRefresh);
    });

    CategoryTagClick();
});

function CategoryTagClick() {
    $(".category-tag").on("click", function(e){
        e.preventDefault();
        const catSelector = $(".OritainBlog #NewsCategoryFilter");
        const tag = $(this).attr('data-title');
        catSelector.val(tag);
        const data = catSelector.serialize();
        const url = (catSelector.val() !== '') ? location.pathname + "?" + data : location.pathname;
        const toRefresh = [".blog-section-refresh"];
        loadAjaxContent(url, toRefresh);
    });
}

function loadAjaxContent(url, toRefresh) {
    $.ajax({
        url: url,
        type: "GET",
        success: function (response) {
            let html = $(response);
            //Update page elements
            $.each(toRefresh, function (index, cl) {
                let element = html.find(cl);
                $(cl).replaceWith(element);
            });

            history.pushState(null, null, url);
            CategoryTagClick();
        },
        error: function () {
            //console.error();
        },
    });
}
